import { CenteredFlexBox } from '../layout/flexBox/FlexBox';
import { pxToRem } from '../../../utils/getFontValue';
import { UIColors } from '../../../constants/UIConstants';
import {
  Box,
  StepConnector,
  StepLabel,
  Stepper,
  stepConnectorClasses,
  stepLabelClasses,
  styled,
  Step,
} from '@mui/material';

export const StyledIconOuterBox = styled(CenteredFlexBox)<{
  state: { active?: boolean };
}>`
  color: ${UIColors.textColors.white};
  background-color: ${UIColors.globalBG.white};
  width: ${({ state }) => (state.active ? pxToRem(76) : pxToRem(72))};
  height: ${({ state }) => (state.active ? pxToRem(76) : pxToRem(72))};
  border-radius: 50%;
  border: ${({ state }) =>
    state.active
      ? `${pxToRem(3)} solid ${UIColors.secondary.emarald}`
      : `${pxToRem(3)} solid ${UIColors.neutrals.grey60}`};
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} rgba(19, 7, 57, 0.12);
  cursor: pointer;
`;

export const StyledIconInnerBox = styled(CenteredFlexBox, {
  shouldForwardProp: (prop) => prop !== 'isCompleted',
})<{
  state: { active?: boolean };
  isCompleted: { completed?: boolean };
}>`
  color: ${UIColors.textColors.white};
  background-color: ${({ state, isCompleted }) =>
    state.active
      ? `${UIColors.secondary.brightBlue}`
      : isCompleted.completed
      ? `${UIColors.primary.navyBlue}`
      : `${UIColors.globalBG.white}`};
  width: ${({ state }) => (state.active ? pxToRem(60) : pxToRem(50))};
  height: ${({ state }) => (state.active ? pxToRem(60) : pxToRem(50))};
  border: ${({ state }) =>
    state.active ? '0' : `${pxToRem(7)} solid ${UIColors.primary.navyBlue}`};
  border-radius: 50%;
`;

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  alignItems: 'stretch',
  '.MuiStep-root': {
    padding: '0',
  },
  '.MuiStepLabel-root': {
    alignItems: 'flex-start',
  },
  '.MuiStepLabel-iconContainer': {
    height: `${pxToRem(76)}`,
    display: 'flex',
    alignItems: 'center',
    zIndex: 2,
    marginLeft: `${pxToRem(20)}`,
  },
  '.MuiStepLabel-labelContainer': {
    textAlign: 'center',
    marginTop: `${pxToRem(-38)}`,
    zIndex: 0,
  },
  '.MuiStepLabel-label': {
    marginTop: 0,
    padding: `${pxToRem(50)} ${pxToRem(16)} ${pxToRem(20)} ${pxToRem(20)}`,
  },
  '.MuiStepLabel-label.Mui-active': {
    backgroundColor: ` ${UIColors.globalBG.grey}`,
  },
}));

export const StyledLabel = styled(StepLabel)(() => ({
  height: '100%',
  [`.${stepLabelClasses.labelContainer}`]: {
    height: '100%',
  },
  [`.${stepLabelClasses.label}`]: {
    height: '100%',
    marginTop: '0 !important',
  },
}));

export const StyledStep = styled(Step)<{
  percentage: { value?: number };
}>(({ percentage }) => {
  const raw = percentage?.value;
  const p = typeof raw === 'number' && Number.isFinite(raw) ? Math.min(100, Math.max(0, raw)) : 0;
  const track = UIColors.neutrals.grey60;
  const fill = UIColors.primary.navyBlue;
  return {
    [`& .${stepConnectorClasses.line}`]: {
      border: 0,
      height: 6,
      borderRadius: 9999,
      background: `linear-gradient(90deg, ${fill} 0%, ${fill} ${p}%, ${track} ${p}%, ${track} 100%)`,
      boxShadow: `inset 0 0 0 1px ${UIColors.neutrals.grey40}`,
    },
  };
});

export const StyledConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: `${pxToRem(36)}`,
    left: `calc(-100% + ${pxToRem(92)})`,
    right: `calc(100% + ${pxToRem(-22)})`,
    zIndex: 1,
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: `${UIColors.primary.navyBlue}`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 0,
    borderColor: `${UIColors.neutrals.grey60}`,
    minHeight: 6,
  },
}));

export const CheckIconBox = styled(Box)`
  background: ${UIColors.secondary.emarald};
  border-radius: 50%;
  height: 1.25rem;
  width: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCheckIconBox = styled(CheckIconBox)`
  position: absolute;
  top: -1.5rem;
  left: 2.92rem;
  background: ${UIColors.secondary.darkGreen};
`;
export const StyledStepperBox = styled(Box)`
  cursor: pointer;
`;